module.exports = __webpack_public_path__ + "assets/img/pro-share-bg.7155a3a5.png";